module.exports = __webpack_public_path__ + "static/media/manvar_logo.a980ca5a.png";